// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"32":"f9a0872c","40":"77cde749","45":"46b9dd66","87":"8e16d4ba","148":"259a3faa","183":"e03b14a7","316":"20e49cff","499":"af234b4b","546":"2c8a5841","609":"13c1e055","757":"6b8e1dd3","871":"799a9352","935":"c3cad1a1"}[chunkId] + ".chunk.js";
};